<dialog-header [dialogRef]="dialogRef" [headerKey]="data ? data.header : 'SELECT_OPTION'"></dialog-header>
<div mat-dialog-content>
  <ng-container *ngIf="data && data.options.length; else noOptions">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-form-field>
        <mat-label>{{ data.controlLabel | translate }}</mat-label>
        <mat-select formControlName="select">
          <mat-option *ngFor="let option of data.options" [value]="option.value">
            {{ option.label | translate }}
          </mat-option>
        </mat-select>
        <mat-error>{{ 'FIELD_ERROR.REQUIRED' | translate }}</mat-error>
      </mat-form-field>
      <dialog-buttons></dialog-buttons>
    </form>
  </ng-container>
  <ng-template #noOptions>
    {{ 'NO_OPTIONS' | translate }}
  </ng-template>
</div>

